import React, { useMemo } from 'react';
import { useQuoteState } from '../../../../../stateProviders/QuoteStateProvider';

export const PriceDisplay: React.FC<{ price: number }> = ({ price }) => {
	const quoteState = useQuoteState();
	console.log(price);

	const discountedCosts = useMemo(() => {
		const discountedPricing: number[] = [price];
		let currentPrice = price;

		quoteState.appliedDiscounts.forEach((discount) => {
			currentPrice = Math.round(
				currentPrice * (1 - discount.discountPercentage / 100)
			);
			discountedPricing.push(currentPrice);
		});

		if (quoteState.managerDiscount) {
			currentPrice = Math.round(
				currentPrice * (1 - quoteState.managerDiscount.percentage / 100)
			);

			discountedPricing.push(currentPrice);
		}

		return discountedPricing;
	}, [price, quoteState.appliedDiscounts, quoteState.managerDiscount]);

	return (
		<>
			{discountedCosts.map((discountedCost, index) => {
				const formattedCost = new Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: 'USD',
				}).format(discountedCost);

				return (
					<span
						key={index}
						className={`${
							discountedCosts.length > index + 1
								? 'line-through opacity-60 italic'
								: 'font-bold'
						}`}
					>
						{formattedCost}
					</span>
				);
			})}
		</>
	);
};
